__turbopack_context__.v({
  "icon": "style-module-scss-module__4EIs9W__icon",
  "link": "style-module-scss-module__4EIs9W__link",
  "listItem": "style-module-scss-module__4EIs9W__listItem",
  "socialLinks": "style-module-scss-module__4EIs9W__socialLinks",
});
